<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates5">
<p class="centerImage"><img alt="images" id="plate5" src="images/plate5.jpg"/></p>
<p class="caption">Look at me, Mum! I get my commission.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates5.vue?41a3d17e